import React, { useState, Fragment } from 'react';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  Label,
  FormGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImageGallery from '../../../propinfo/gallery/index';
import IntlMessages from '../../../../../../helpers/IntlMessages';

function HeroResponse({
  dialogUpdate,
  elem,
  dialogIndex,
  codeIndex,
  message,
  propertyId,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [inputFields, setInputFields] = useState(message.actions);
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const [title, setTitle] = useState(
    message.title === undefined ? '' : message.title
  );
  const [subTitle, setSubTitle] = useState(
    message.subtitle === undefined ? '' : message.subtitle
  );
  const [imageURL, setImageURL] = useState(
    message.imageURL === undefined ? '' : message.imageURL
  );
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState(elem);

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: '',
      title: '',
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'type') {
      values[index].type = event.target.value;
    } else {
      values[index].title = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const selectedImage = (link) => {
    console.log(link);
    setImageURL(link.src);
  };
  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    const data = { ...postData };
    data.messages.splice(codeIndex, 1);
    dialogUpdate(postData, dialogIndex);
    toggle();
  };
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };
  const handleSubTitleChange = (e) => {
    setSubTitle(e.target.value);
  };
  const handleImageChange = (e) => {
    setImageURL(e.target.value);
  };

  const handleSave = () => {
    const data = { ...postData };
    data.messages[codeIndex].title = title;
    data.messages[codeIndex].subtitle = subTitle;
    data.messages[codeIndex].imageURL = imageURL;
    data.messages[codeIndex].actions = inputFields;
    dialogUpdate(data, dialogIndex);
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
    setInputFields(message.actions);
    setTitle(message.title === undefined ? '' : message.title);
    setSubTitle(message.subtitle === undefined ? '' : message.subtitle);
    setImageURL(message.imageURL === undefined ? '' : message.imageURL);
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Card className="mb-2">
      <CardBody>
        {isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <Colxx xxs="6">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Hero Card
                </Colxx>
                <Colxx xxs="6">
                  <div className="float-right">
                    <Button
                      color="primary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <b> </b>
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Colxx>
              </Row>{' '}
            </CardTitle>
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={title}
                  onChange={handleTitleChange}
                  placeholder="title"
                />
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={subTitle}
                  onChange={handleSubTitleChange}
                  placeholder="subtitle"
                />
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  value={imageURL}
                  onChange={handleImageChange}
                  placeholder="Image Url"
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <div
                  className="float-left"
                  style={{ marginTop: ' 5px', marginBottom: '5px' }}
                >
                  <Button
                    color="primary"
                    className="add-button"
                    size="xs"
                    onClick={togglegallery}
                  >
                    <IntlMessages id='dashboards.browsegallery' />
                  </Button>
                </div>
              </Colxx>
            </Row>
            <Row>
              {inputFields.map((domain, index) => (
                <Fragment key={index}>
                  <Colxx sm={4} className="md-3">
                    <Label>Type</Label>
                    <Input
                      type="select"
                      value={domain.type}
                      name="type"
                      onChange={(event) => handleInputChange(index, event)}
                    >
                      <option value="">Please select</option>
                      <option value="imBack">Send to Bot</option>
                      <option value="openUrl">Open in Browser</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="title">Title</Label>
                      <Input
                        type="text"
                        key={`priority_${index}`}
                        name="title"
                        id="title"
                        defaultValue={domain.title}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                    </FormGroup>
                  </Colxx>
                  {/* <Colxx sm={3}>
                    <FormGroup>
                      <Label for="value">Value</Label>
                      <Input
                        type="text"
                        key={`value_${index}`}
                        name="value"
                        id="value"
                        defaultValue={domain.value}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                    </FormGroup>
                  </Colxx> */}
                  <Colxx sm={2} className="mb-3">
                    <Label>Remove</Label>
                    <div>
                      <Button
                        onClick={() => handleRemoveFields(index)}
                        color="secondary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                      >
                        -
                      </Button>
                    </div>
                  </Colxx>
                </Fragment>
              ))}
            </Row>
            <Button
              onClick={handleAddFields}
              color="primary"
              size="xs"
              outline
              style={{ margin: '6px' }}
            >
              + Add Action
            </Button>
            {ImageGalleryButton()}
          </Fragment>
        ) : (
          <Fragment>
            <CardTitle>
              <Row>
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Hero Card
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={toggle}
                    />
                  </div>
                </Colxx>
              </Row>
            </CardTitle>
            <Row>
              <Colxx xxs="12">
                {message.title && (
                  <p>
                    <b>Title:</b> {message.title}{' '}
                  </p>
                )}
                {message.subtitle && (
                  <p>
                    <b>Subtitle:</b> {message.subtitle}{' '}
                  </p>
                )}
                {message.imageURL && (
                  <p>
                    <CardImg src={message.imageURL} />
                  </p>
                )}
                {message.actions.map((action, index) => {
                  return (
                    <div className="mb-2">
                      <b>Title:</b> {action.title} <b>Type:</b> {action.type}{' '}
                    </div>
                  );
                })}
              </Colxx>
            </Row>
            <Modal isOpen={deleteVisible} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                This message will be deleted!
              </ModalHeader>
              <ModalBody>
                <Button color="danger" onClick={() => handleDelete()} size="xs">
                  Delete
                </Button>
                <Button
                  className="ml-2"
                  color="dark"
                  outline
                  size="xs"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
          </Fragment>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(HeroResponse));
